import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class CustomTypeService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getAllCustomTypes(accountId: number, siteId: number, isActiveOnly: boolean = false): Observable<any> {

        let url = `CustomType/GetAll?id=${accountId}&siteId=${siteId}&isActiveOnly=${isActiveOnly}`;
        return super.getAll<any>(url);
    }

    public getCustomType(id?: number): Observable<any> {
        let url = `CustomType/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public saveCustomType(data) {
        let url = `CustomType/Save`;
        return super.save<any>(url, data);
    }

    public deleteCustomType(data) {
        let url = `CustomType/Delete?id=${data}`;
        return super.save<any>(url, data);
    }

    public toggleIsActive(id) {
        let url = `CustomType/IsActive?id=${id}`
        return super.save<any>(url, null)
    }

}



// WEBPACK FOOTER //
// ./src/app/services/custom-type.service.ts